import React from 'react';
import { TextField } from '@mui/material';

const TextArea = ({ label, value, onChange }) => {
  return (
    <TextField
      label={label}
      variant="outlined"
      multiline
      minRows={8}
      maxRows={20}
      fullWidth
      value={value}
      onChange={onChange}
    />
  );
};

export default TextArea;
